module.exports = __webpack_public_path__ + "media/images/icons8-deadlift-a27ceb1788b069ea7ef64bab70a05ab2.svg";